/* eslint-disable  */
import React, { useState, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { PublicClientApplication } from "@azure/msal-browser";
import { MicrosoftLoginButton } from "react-social-login-buttons";
import Loading from "react-loading";
import { UserState } from "../../interfaces";
import { useStyles } from "../../constants/styles";
import { Card, Container } from "./styles";
import { data } from "../../utils/auth_azure";
import Auth from "../../services/signIn";
import warn from "../../constants/toast";
import { Button, ContainerButton, TextButton } from "./styles";
import { TiVendorMicrosoft } from "react-icons/ti";

const Login = (props: any) => {
  const dispatch = useDispatch();
  const { signed, isError } = useSelector<RootStateOrAny, UserState>(
    (state) => state.user
  );
  const [instance, setInstance] = useState<PublicClientApplication>();
  const [loading, setLoading] = useState(false);

  if (signed) {
    props.history.push("/menu");
  }

  useEffect(() => {
    initClient();
  }, []);

  useEffect(() => {
    if (isError) {
      dispatch({ type: "SET_IS_ERROR", payload: true });
    }
  }, [isError]);

  const initClient = () => setInstance(data);

  const SinIgn = async () => {
    try {
      setLoading(true);
      await Auth(instance);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      warn.wargingAlert("Não foi possível realizar sua autenticação!");
    }
  };

  return (
    <Container>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <span
          style={{
            marginTop: 50,
            marginBottom: 15,
            fontSize: 18,
            color: "#525252",
            fontFamily: "Graphik-Regular",
          }}
        >
          PORTAL-ADMIN
        </span>

        <Card>
          <form className={useStyles().form} onSubmit={SinIgn}>
            {loading ? (
              <>
                {/* @ts-ignore */}
                <Loading />
              </>
            ) : (
              <>
                {/* @ts-ignore */}

                <Button onClick={() => SinIgn()} type="submit">
                  <ContainerButton>
                    <TiVendorMicrosoft color="#fff" size={24} />

                    <TextButton>LOGIN COM MICROSOFT</TextButton>
                  </ContainerButton>
                </Button>
                {/* <MicrosoftLoginButton
                  activeStyle={{ backgroundColor: "#414141" }}
                  style={{ backgroundColor: "#414141", fontSize: 14 }}
                  align="center"
                  text="LOGIN COM MICROSOFT"
                  onClick={() => SinIgn()}
                /> */}
              </>
            )}
          </form>
        </Card>
      </div>
    </Container>
  );
};
export default Login;
